class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0; // Store the last scroll position
      this.isSticky = false; // Track whether the header is currently sticky
      this.headerHeight = 0; // Store the height of the header for proper padding
      this.onScrollHandler = this.debounce(this.onScroll.bind(this), 50);
    }

    connectedCallback() {
      this.header = this.closest('#shopify-section-header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.enableStickyHeader = [true, 'true'].includes(this.dataset.enableStickyHeader);
      this.announcementBar = document.querySelector('announcement-bar');
      this.isTransparent = this.hasAttribute('data-transparent');
      this.dropdownLinks = this.querySelectorAll('[data-expand-on-hover]');
      this.navItems = this.querySelectorAll('.header__nav__item');
      this.overlay = this.querySelector('[data-overlay]');
      this.headerOffset = document.querySelector('#shopify-section-announcement-bar')?.offsetHeight || 0;
      this.searchOpener = this.querySelectorAll('[data-search-opener]');
      this.searchCloser = this.querySelectorAll('[data-search-closer]')
      this.searchModal = this.querySelector('.header__search');

      this.setHeaderOffset();

      this.header = this.closest('#shopify-section-header');
      this.headerHeight = this.header.offsetHeight; // Set header height
      this.enableStickyHeader = [true, 'true'].includes(this.dataset.enableStickyHeader);

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.setHeaderOffset.bind(this));
      this.dropdownLinks.forEach((link) => {
        link.addEventListener('mouseenter', (event) => this.dropdownOverlayToggle(event));
        link.addEventListener('mouseleave', (event) => this.dropdownOverlayToggle(event));
      })
      if (this.searchOpener && this.searchCloser) { 
        this.searchOpener.forEach(btn => btn.addEventListener('click', this.openSearch.bind(this)));
        this.searchCloser.forEach(btn => btn.addEventListener('click', this.closeSearch.bind(this)));
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    openSearch() { 
      this.searchModal.classList.add('open');
    }
  
    closeSearch() { 
      this.searchModal.classList.remove('open');
    }
  
    setHeaderOffset() {
      if (!this.isTransparent) {
        return;
      }

      let offset = 0;
      const headerInner = this.header.querySelector('.header__inner');
      const headerInnerHeight = headerInner.clientHeight || 0;
      const isAnnouncementBelow = this.announcementBar?.classList.contains('announcement-bar--is-bellow') || false;

      offset += headerInnerHeight;

      if (isAnnouncementBelow && this.announcementBar) {
        offset += this.announcementBar.clientHeight;
        this.announcementBar.style.top = `${offset}px`;
      }

      this.header.style.marginBottom = `-${offset}px`;
    }

    debounce(func, delay) {
      let timeoutId;
      return function(...args) {
          if (timeoutId) {
              clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(() => {
              func.apply(this, args);
          }, delay);
      };
   }

   onScroll() {
    if (!this.enableStickyHeader || this.header.classList.contains('menu-open')) {
        return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate if scrolled down enough to show the header
    const shouldShowHeader = scrollTop > this.headerHeight;

    // Determine if scrolling up
    const isScrollingUp = scrollTop < this.lastScrollTop;

    // Update last scroll position
    this.lastScrollTop = scrollTop;

    if (shouldShowHeader) {
        if (isScrollingUp && !this.isSticky) {
            this.isSticky = true; // Set sticky state
            requestAnimationFrame(this.reveal.bind(this));
        } else if (!isScrollingUp && this.isSticky) {
            this.isSticky = false; // Clear sticky state
            requestAnimationFrame(this.reset.bind(this));
        }
    } else if (this.isSticky) {
        this.isSticky = false; // Clear sticky state if not scrolled enough
        requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('sticky-header-show');

      // Adjust padding of the body or announcement bar if necessary
      this.adjustPadding(true);
  }

  reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('sticky-header-show');

      // Reset padding of the body or announcement bar
      this.adjustPadding(false);
  }

  adjustPadding(add) {
      const isAnnouncementBelow = this.announcementBar?.classList.contains('announcement-bar--is-bellow') || false;

      if (this.announcementBar) {
          if (add) {
              this.announcementBar.parentElement.style[isAnnouncementBelow ? 'paddingTop' : 'paddingBottom'] = `${this.headerHeight}px`;
          } else {
              this.announcementBar.parentElement.style[isAnnouncementBelow ? 'paddingTop' : 'paddingBottom'] = '0px';
          }
      }
  }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (!this.searchModal) {
        return;
      }

      this.searchModal.close(false);
    }

    dropdownOverlayToggle(event) {
      if (!this.overlay) {
        return;
      }
      
      if (event.type === 'mouseenter') {
        
        this.megaMenuTimeout = setTimeout(() => {
          event.target.classList.add('mega-visible');
          this.overlay.classList.add('is-visible');
        }, 150);
      } else {
        
        if (this.megaMenuTimeout) {
          clearTimeout(this.megaMenuTimeout);
        }
        event.target.classList.remove('mega-visible');
        this.overlay.classList.remove('is-visible');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);
